const LayoutWrapper = ({ children }) => {
    return <div style={{
        // height: "940px",
        // aspectRatio: "16/9",
        // paddingTop: "147px",
        // display: "flex",
        // justifyContent: "center",
        // backgroundImage: `url(${require(`../../../assets/images/live-v2/bg-1.png`)})`,
        // backgroundRepeat: "no-repeat",
        // backgroundSize: "100% 100%",
    }}>
        {children}
    </div>
}

export default LayoutWrapper;